import React, { useState } from 'react';
import { Container, Accordion, Icon } from 'semantic-ui-react';
import './App.css';

import PictureArea from './components/PictureArea';
import SubtitleEdit from './components/SubtitleEdit';
import Usage from './components/Usage';

function App() {
  /** 字幕段数。実際にはここの数値を変えつつ、PictureArea.cssで字幕エリアの高さの調整が必要 */
  const SUBTITLES_NUM = 4;

  /** 字幕パラメータ */
  const [subtitleParam, setSubtitleParam] = useState(Array(SUBTITLES_NUM).fill(
    { text: '', left: 5, colorCode: '#ffffff' }
  ));
  /** 字幕設定のアコーディオン状態 */
  const [accordionState, setAccordionState] = useState(Array(SUBTITLES_NUM).fill(false));

  const onChangeText = (position: number, newText: string) => {
    const newVal = subtitleParam.slice();
    newVal[position] = { text: newText, left: newVal[position].left, colorCode: newVal[position].colorCode }
    setSubtitleParam(newVal)
  }
  const onChangeLeft = (position: number, newLeft: number) => {
    const newVal = subtitleParam.slice();
    newVal[position] = { text: newVal[position].text, left: newLeft, colorCode: newVal[position].colorCode }
    setSubtitleParam(newVal)
  }
  const onChangeColor = (position: number, newColorCode: string) => {
    const newVal = subtitleParam.slice();
    newVal[position] = { text: newVal[position].text, left: newVal[position].left, colorCode: newColorCode }
    setSubtitleParam(newVal)
  }

  return (
    <Container className="App">
      <h1>字幕放送風画像メーカー</h1>
      <div>
        好きな画像でテレビの字幕放送っぽい画像をつくろう！
      </div>
      <div className='ShareButtonArea'>
        <a
          href="https://twitter.com/share?ref_src=twsrc%5Etfw"
          className="twitter-share-button"
          data-text="字幕放送風画像メーカーで字幕放送風画像をつくろう！"
          data-url="https://subtitle-picture-maker.netlify.app/"
          data-hashtags="字幕放送風画像メーカー"
          data-lang="ja"
          data-show-count="false">Tweet</a>
        <div
          className="line-it-button"
          data-lang="ja"
          data-type="share-a"
          data-ver="3"
          data-url="https://subtitle-picture-maker.netlify.app/"
          data-color="default"
          data-size="small"
          data-count="false"
          style={{display: 'none'}}></div>
        <br />
        ↑よければ広めてあげてください↑
      </div>

      <PictureArea subtitleParam={subtitleParam} />

      <Accordion styled fluid>
        {[...Array(SUBTITLES_NUM)].map((_, idx) => {
          return (
            <div key={idx}>
              <Accordion.Title
                index={idx}
                active={accordionState[idx]}
                onClick={() => {
                  const newVal = accordionState.slice();
                  newVal[idx] = !newVal[idx];
                  setAccordionState(newVal);
                }}
              >
                <Icon name='dropdown' />{idx + 1}段目の字幕設定
              </Accordion.Title>
              <Accordion.Content active={accordionState[idx]}>
                <SubtitleEdit 
                  key={idx}
                  onChangeText={(newText) => { onChangeText(idx, newText) }}
                  onChangeLeft={(newLeft) => { onChangeLeft(idx, newLeft) }}
                  onChangeColor={(newColorCode) => { onChangeColor(idx, newColorCode) }} />
              </Accordion.Content>
            </div>
          );
        })}
      </Accordion>

      <Usage />

      <div className='Footer'>
        (c) 2021 Nano-Nano
        <span>
          Twitter: 
          <a href='https://twitter.com/nano2_aloerina' target='_blank' rel='noopener noreferrer'>@nano2_aloerina</a>
        </span>
        <span>
          GitHub: 
          <a href='https://github.com/nano-nano' target='_blank' rel='noopener noreferrer'>nano-nano</a>
        </span>
      </div>
    </Container>
  );
}

export default App;
